import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  Container,
  Button,
  Card,
  Grid,
  Typography,
  Step,
  StepLabel,
  useMediaQuery,
} from '@mui/material';
import * as Yup from 'yup';
import './styles.css';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import { useStyles } from '../../components/Styles';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import { CustomStepper } from 'components/CustomStepper/CustomStepper';
import FarmGif from '../../images/gifs/gif-tela-criar-fazenda.gif';
import WelcomeText from './formSteps/welcomeText/welcomeText';
import { PondInfoOne, PondInfoTwo } from './formSteps/pondInfo/pondInfo';
import { setSelectedCycle } from 'redux/selectedCycle';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HandleSelectedProperty from 'components/HandleSelectedProperty';

function FirstPond() {
  const [property, setProperty] = useState(null);
  const [showAlertDialog, setShowAlertDialog] = useState(false);
  const [hasPondWithThisDescription, setHasPondWithThisDescription] = useState(
    false,
  );
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [finishIsOpen, setFinishIsOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [cycles, setCycles] = useState(null);
  const [isInCycle, setIsInCycle] = useState(false);
  const [openDialogPondExists, setDialogPondExists] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [thereIsPond, setThereIsPond] = useState(false);

  const [firstAccessDisable, setFirstAccessDisable] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);
  const [openHandleProperty, setOpenHandleProperty] = useState(true);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);

  const notIsFirstAccess = useSelector(
    (state) => state.notIsFirstAccess.notIsFirstAccess,
  );

  const matches = useMediaQuery('(max-width:900px)');

  useEffect(() => {
    async function ini() {
      setUser(await api.get('users'));
    }
    ini();
  }, []);

  useEffect(() => {
    if (user?.data.firstAccess === true) setDialogIsOpen(true);
  }, [user]);

  const selectedCycle = useSelector(
    (state) => state.selectedCycle.selectedCycle,
  );

  useEffect(() => {
    async function cycle() {
      if (user?.data.firstAccess === false) {
        setCycles(await api.get('cycles'));
      }
    }
    cycle();
  }, [user]);

  useEffect(() => {
    if (cycles?.data) {
      cycles.data.forEach((cycle) => {
        if (cycle.pond?.id == id) setIsInCycle(true);
      });
    }
  }, [cycles]);

  const handleSetCycle = (selected) => {
    localStorage.setItem('selected-cycle', JSON.stringify(selected));
    dispatch(setSelectedCycle(selected));
  };

  const location = useLocation();
  const disable = useSelector((state) => state.disable.disable);
  const history = useHistory();
  const dispatch = useDispatch();
  let { id } = useParams();
  const classes = useStyles();
  const error = Error();

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      property_id: '',
      capacity: '',
      description: '',
      type: '',
      status: '',
      system: '',
      protocol: '',
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Campo Obrigatório'),
      description: Yup.string().required('Campo Obrigatório'),
      capacity: Yup.number()
        .required('Campo Obrigatório')
        .min(0, 'Precisa ser acima de 0'),
      type: Yup.string().required('Campo Obrigatório'),
      system: Yup.string().required('Campo Obrigatório'),
      protocol: Yup.string().required('Campo Obrigatório'),
    }),
    onSubmit: async (values) => {
      if (!hasPondWithThisDescription) {
        dispatch(setLoading(true));
        values.property_id = property.id;
        request(values);
      } else {
        setShowAlertDialog(true);
      }
    },
  });

  // relodar a página
  useEffect(() => {
    async function load() {
      try {
        setOpenProgress(true);
        // carrega os dados no seu devido campo caso tenha id, do contrário,
        // carrega o formulário vazio para cadastrar um novo
        global.loading = true;

        const resp = await api.get('/properties');

        if (resp.data) {
          setProperty(resp.data);
        }

        // if(pond.data[pathname]){
        //   formik.setValues(pond.data[pathname])
        //   setThereIsPond(true)
        // }

        global.loading = false;
      } catch (err) {
        console.error(err);
      } finally {
        setOpenProgress(false);
      }
    }
    load();
  }, []);

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    try {
      if (id || thereIsPond) {
        await api.put(`/ponds/${id}`, { ...data });
      } else {
        await api.post('/ponds', [{ ...data }]);
        api.post('cycle-codes').then((r) => {
          api.get('/cycle-codes').then((resp) => setCycles(resp.data));
          handleSetCycle(r.data);
          dispatch(setLoading(false));
        });
      }

      Success();
    } catch (err) {
      if (err.response.data.statusCode === 400) {
        if (openDialogPondExists === true) {
          setDialogPondExists(false);
        }
        setDialogPondExists(true);
        setMessageError(err.response.data.message);
      }
      error(err);
    } finally {
      dispatch(setDisable(false));
      dispatch(setLoading(false));
      setOpenProgress(false);
      if (!notIsFirstAccess) {
        setFinishIsOpen(true);
        history.push(!notIsFirstAccess ? '/first-cycle' : '/cycle');
      } else history.push('/ponds');
    }
  }

  async function hasPond(description) {
    // const cpfCnpjConverted = cpfCnpj.replace(/\D+/g, '')
    //
    setTimeout(async () => {
      const { data } = await api.get(
        `/ponds/description/${description.trim()}`,
      );

      return data
        ? setHasPondWithThisDescription(true)
        : setHasPondWithThisDescription(false);
    }, 200);
  }

  const [disableNextStep, setDisableNextStep] = useState(false);
  const [step, setStep] = useState(0);
  const steps = ['Passo 1', 'Passo 2'];

  return (
    <Container style={{ padding: '3.5rem 8.125rem 3.5rem 8.9rem' }}>
      {!notIsFirstAccess && (
      <HandleSelectedProperty
        nameProperty={nameProperty}
        openHandleProperty={openHandleProperty}
            // dispatch={dispatch}
        setOpenHandleProperty={setOpenHandleProperty}
      />
      )}
      {openProgress && <Progress />}
      <Card className={classes.roundedPaper}>
        <Grid container className={classes.centralized}>
          <Grid
            item
            xs={10}
            container
            className={classes.centralized}
            style={{ height: '68vh' }}
          >
            {step === 0 ? <WelcomeText setStep={setStep} /> : null}

            {step > 0 && (
            <Grid
              container
              component="form"
              className={`${classes.root} ${classes.centralized}`}
              onSubmit={formik.handleSubmit}
              style={{ padding: '0 1rem' }}
            >
              {step === 1 ? <PondInfoOne formik={formik} /> : null}
              {step === 2 ? <PondInfoTwo formik={formik} /> : null}
              {step > 0 ? (
                <section
                  style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%',
                  }}
                >
                  <div>
                    <CustomStepper activeStep={step - 1}>
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel />
                        </Step>
                      ))}
                    </CustomStepper>
                  </div>
                  <div style={{ display: 'flex' }}>
                    {step > 1 ? (
                      <div style={{ marginInline: '1rem' }}>
                        <Button
                          className={classes.roundedButton}
                          style={{ borderRadius: '15px' }}
                          onClick={() => {
                            setStep((prev) => prev - 1);
                          }}
                          variant="text"
                        >
                          <Typography style={{ textTransform: 'none', paddingInline: '1rem' }}>Voltar</Typography>
                        </Button>
                      </div>
                    ) : null}
                    {step > 0 && step < 2 ? (
                      <Grid>
                        <Button
                          className={classes.roundedButton}
                          onClick={() => {
                            switch (step) {
                              case 1: {
                                if (
                                  formik.touched.description
                                      && formik.touched.capacity
                                      && formik.touched.type
                                      && !formik.errors.description
                                      && !formik.errors.capacity
                                      && !formik.errors.type
                                ) {
                                  setStep((prev) => prev + 1);
                                }
                                break;
                              }
                              case 2: {
                                if (
                                  formik.touched.system
                                      && formik.touched.status
                                      && formik.touched.protocol
                                      && !formik.errors.system
                                      && !formik.errors.status
                                      && !formik.errors.protocol
                                ) {
                                  setStep((prev) => prev + 1);
                                }
                                break;
                              }
                              default:
                                return setDisableNextStep(true);
                            }
                          }}
                          variant="contained"
                          style={{
                            backgroundColor: disableNextStep
                              && 'gray',
                          }}
                        >
                          <Typography style={{ textTransform: 'none', paddingInline: '1rem' }}>
                            {!matches ? 'Próximo' : <ArrowForwardIcon />}
                          </Typography>
                        </Button>
                      </Grid>
                    ) : (
                      <Grid>
                        <Button
                          className={classes.roundedButton}
                          type={formik.isValid ? 'submit' : 'button'}
                          disabled={!formik.isValid}
                          variant="contained"
                          style={{
                            backgroundColor: !formik.isValid
                              && 'gray',
                          }}
                        >
                          <Typography style={{ textTransform: 'none', paddingInline: '1rem' }}>Concluir</Typography>
                        </Button>
                      </Grid>
                    )}
                  </div>
                </section>
              ) : null}
            </Grid>
            )}
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
}

export default FirstPond;
